import { render } from "./Signature.vue?vue&type=template&id=78f5eb75"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/File/Signature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78f5eb75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78f5eb75', __exports__)) {
    api.reload('78f5eb75', __exports__)
  }
  
  module.hot.accept("./Signature.vue?vue&type=template&id=78f5eb75", () => {
    api.rerender('78f5eb75', render)
  })

}


export default __exports__